import React from 'react';
import * as _ from 'lodash';
import stringSimilarity from 'string-similarity-js';
import { getProxyUrl } from '../utils/image';

function PlayerStatsTable({ playerStats, teamLogos }) {
  const teamLogosAsArr = Object.keys(teamLogos).map((x) => teamLogos[x]);

  const getTeamLogo = (team) => {
    if (team.includes('Team ')) {
      const country = team
        .replace('Team', '')
        .replace('U21', '')
        .replace('U23', '')
        .replace('U19', '')
        .trim();
      const flagUrl = `https://storage.googleapis.com/connectedleaguedata.appspot.com/flags/${country.toLowerCase()}.png`;
      const proxyFlagUrl = getProxyUrl(flagUrl, 50, 50);
      return proxyFlagUrl;
    }

    const logo = teamLogosAsArr.find((t) => {
      const result = stringSimilarity(team, t.name, undefined, false);
      return result > 0.74;
    });

    const logoImageUrl = _.get(logo, 'logoImageUrl', null);
    const proxyLogoImageUrl = logoImageUrl
      ? getProxyUrl(logoImageUrl, 50, 50)
      : '/wp-content/themes/sef-leagues/images/generic-team.png';

    return proxyLogoImageUrl;
  };

  const renderStatsRow = (statRowData) => {
    const team = statRowData?.teamName;
    const logo = getTeamLogo(team);

    return (
      <div className="stats-table__row" style={{ minWidth: '775px' }}>
        <div className="stats-table__generic">{statRowData.year}</div>
        <div className="stats-table__generic stats-table__generic--team-name flex-lg-grow-1 d-flex">
          <div className="name-with-team-logo">
            <img src={logo} alt="" />
            <span className="text-color-primary-yellow">
              {statRowData.teamName}
            </span>
          </div>
        </div>
        <div className="stats-table__generic text-start">
          {statRowData.leagueName}
        </div>
        <div className="stats-table__generic text-end">
          {statRowData.matchesPlayed}
        </div>
        <div className="stats-table__generic text-end">
          {statRowData.matchesStarted}
        </div>
        <div className="stats-table__generic text-end">{statRowData.goals}</div>
        <div className="stats-table__generic text-end">
          {statRowData.assists}
        </div>
        <div className="stats-table__generic text-end">
          {statRowData.yellowCards}
        </div>
        <div className="stats-table__generic text-end">
          {statRowData.redCards}
        </div>
      </div>
    );
  };

  return (
    <div className="stats-table stats-table--scrollable overflow-x-auto">
      <div className="stats-table__row stats-table__row--header">
        <div className="stats-table__generic heading-stats-name">ÅR</div>
        <div className="stats-table__generic stats-table__generic--team-name flex-lg-grow-1">
          Lag
        </div>
        <div className="stats-table__generic heading-stats-name text-start">
          Serie
        </div>
        <div className="stats-table__generic heading-stats-name text-end">
          Spelade
        </div>
        <div className="stats-table__generic heading-stats-name text-end">
          Startade
        </div>
        <div className="stats-table__generic heading-stats-name text-end">
          Mål
        </div>
        <div className="stats-table__generic heading-stats-name text-end">
          Assist
        </div>
        <div className="stats-table__generic heading-stats-name text-end">
          Gula
        </div>
        <div className="stats-table__generic heading-stats-name text-end">
          Röda
        </div>
      </div>
      {playerStats?.map((statRow) => renderStatsRow(statRow))}
    </div>
  );
}

export default PlayerStatsTable;
